export const windowProperty = '__requestAttributes';
